module.exports = __webpack_public_path__ + "img/social-icon-fb.fd82d3f1.svg";